// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Red_Hat_Display_49415d', '__Red_Hat_Display_Fallback_49415d'","fontStyle":"normal"},"className":"__className_49415d","variable":"__variable_49415d"};